










import Vue from 'vue';
import { Modal, ModalMixin } from 'mycorems-app-shared';
import { User, UserRole } from '../types';
import UserRoles from './UserRoles.vue';

export default Vue.extend({
  mixins: [ModalMixin],
  props: {
    user: {
      type: Object as () => User,
      required: true,
    },
  },
  computed: {
    title(): string {
      return `${this.user.firstName} ${this.user.lastName} - Roles`;
    },
  },
  methods: {
    assign(userRole: UserRole) {
      this.user.roles.push(userRole);
    },
    unassign(userRole: UserRole) {
      const index = this.user.roles.findIndex(ur => ur.id === userRole.id);
      if (index >= 0) {
        this.user.roles.splice(index, 1);
      }
    },
  },
  components: {
    Modal,
    UserRoles,
  },
});
